import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import { Link } from '@tanstack/react-router';
import { hasRespondedToConsent, setConsent } from '~/utils/analyticsConsent';
import messages from './messages';

const BannerRoot = styled(Paper)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: theme.zIndex.snackbar,
  padding: theme.spacing(2, 3),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  flexWrap: 'wrap',
  borderRadius: 0,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
}));

const ButtonGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  flexShrink: 0,
}));

const CookieConsentBanner = () => {
  const [dismissed, setDismissed] = useState(() => hasRespondedToConsent());

  if (dismissed) return null;

  const handleAccept = () => {
    setConsent('analytics', true);
    // Reload so PostHogConsentManager picks up the new cookie and initializes PostHog
    window.location.reload();
  };

  const handleDecline = () => {
    setConsent('analytics', false);
    setDismissed(true);
  };

  return (
    <BannerRoot elevation={8}>
      <Typography variant="body2" sx={{ flex: 1 }}>
        <FormattedMessage {...messages.bannerText} />{' '}
        <Link to="/privacy">
          <FormattedMessage {...messages.privacyPolicyLink} />
        </Link>
      </Typography>
      <ButtonGroup>
        <Button variant="outlined" size="small" onClick={handleDecline}>
          <FormattedMessage {...messages.decline} />
        </Button>
        <Button variant="contained" size="small" onClick={handleAccept}>
          <FormattedMessage {...messages.accept} />
        </Button>
      </ButtonGroup>
    </BannerRoot>
  );
};

export default CookieConsentBanner;
